import { render, staticRenderFns } from "./project-guwen.vue?vue&type=template&id=1f0ffc90&scoped=true&"
import script from "./project-guwen.vue?vue&type=script&lang=js&"
export * from "./project-guwen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ffc90",
  null
  
)

export default component.exports